import script from "./DarkModeToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./DarkModeToggle.vue?vue&type=script&setup=true&lang=js"

import "./DarkModeToggle.vue?vue&type=style&index=0&id=959e9b2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-959e9b2c"]])

export default __exports__